import axios from 'axios';

export class ValueTypeService {
    getValueTypes() {
        return axios.get('/appapv/getValueTypes.action', {}).then(res => res.data);
    }

    editLabelValueType(id, label) {
        return axios.post('/appapv/editLabelValueType.action', {}, {
            params: {
                id: id,
                etiqueta: encodeURIComponent((label)),
            }
        }).then(res => res.data);
    }

    deleteGroup(id) {
        return axios.post('/appapv/deleteGroup.action', {}, {
            params: {
                id: id,
            }
        }).then(res => res.data);
    }

    getValueTypesWithoutGroup() {
        return axios.get('/appapv/getValueTypesWithoutGroup.action', {}).then(res => res.data);
    }

    createGroup(label, ids) {
        return axios.post('/appapv/createGroup.action', {}, {
            params: {
                etiqueta: encodeURIComponent((label)),
                listaIds: ids,
            }
        }).then(res => res.data);
    }

    getValueTypeInGroup(id) {
        return axios.get('/appapv/getValueTypeInGroup.action', {
            params: {
                id: id,
            }
        }).then(res => res.data);
    }

    editGroup(id, label, ids) {
        return axios.post('/appapv/editGroup.action', {}, {
            params: {
                id: id,
                etiqueta: encodeURIComponent((label)),
                listaIds: ids,
            }
        }).then(res => res.data);
    }
}